import { SubsType } from '../../redux/types';
import { TKeys } from '../../i18n/en';
import media from '../../assets/IONNYK-discovery wall website.jpeg';
import media_free from '../../assets/Taste of Ionnyk.jpeg';

/* Copy lives in i18n, not here: `name` and `desc` hold translation keys that
   ProductDetail resolves at render time, so the page follows the language
   picker instead of being English-only.

   Prices are NOT declared here either: ProductDetail renders them from the
   `pricings` returned by GET /client/v1/subscriptions, which is per-environment
   Stripe data. */
export const productInfos: Record<
  SubsType,
  {
    order: number;
    name: TKeys;
    subscriptionType: SubsType;
    desc: (TKeys | TKeys[])[];
    media: string;
  }
> = {
  [SubsType.TASTE]: {
    order: 1,
    subscriptionType: SubsType.TASTE, // FIXME
    name: 'plan_taste_name',
    desc: [
      'plan_taste_intro',
      ['plan_taste_f1', 'plan_taste_f2', 'plan_taste_f3'],
      'plan_taste_outro',
    ],
    media: media_free,
  },
  [SubsType.DISCOVERY]: {
    order: 2,
    name: 'plan_discovery_name',
    subscriptionType: SubsType.DISCOVERY, // FIXME
    desc: [
      'plan_discovery_intro',
      ['plan_discovery_f1', 'plan_discovery_f2', 'plan_discovery_f3', 'plan_discovery_f4'],
      'plan_discovery_outro',
    ],
    media,
  },
  [SubsType.SIGNATURE]: {
    order: 3,
    name: 'plan_signature_name',
    subscriptionType: SubsType.SIGNATURE, // FIXME
    desc: [
      'plan_signature_intro',
      [
        'plan_signature_f1',
        'plan_signature_f2',
        'plan_signature_f3',
        'plan_signature_f4',
        'plan_signature_f5',
      ],
      'plan_signature_outro',
    ],
    // TODO IONK-383: replace with a dedicated Signature visual once design delivers it.
    media,
  },
};
